import { Badge, Card, Heading, Text } from '@ui/themed';
import { t } from 'i18next';
import { formatPlanPrice } from '../lib/format-price';
import type { BillingPlan } from '../types/plan';
import { BulletPoint } from './plan-card-bullets';

export function CurrentPlanCard({
  plan,
  bulletsHeading,
}: {
  plan: BillingPlan;
  bulletsHeading: string;
}) {
  const priceLabel = formatPlanPrice(plan.price);

  return (
    <Card>
      <Card.Body>
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-1">
            <div className="flex items-center justify-between">
              <Text variant="secondary">{plan.name}</Text>
              <Badge variant="blue">
                {t('features:billing.components.current_plan_card.badge')}
              </Badge>
            </div>
            <Heading level="h2" style="xl">
              {priceLabel}
            </Heading>
            <Text variant="secondary">
              {t('features:billing.components.plan_card.price.usd_per_month')}
            </Text>
          </div>

          <Text>{plan.description}</Text>

          <div className="flex flex-col gap-1">
            <Text bold>{bulletsHeading}</Text>
            <div className="grid grid-cols-2 gap-x-3 gap-y-1 md:grid-cols-3">
              {plan.points.map((point) => (
                <BulletPoint key={point.text} point={point} />
              ))}
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
